import React from "react";
import { ChangeEvent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { appInsights } from "../../config/appInsights";
import ButtonLoader, { Loader } from "../../UI/Loaders/Loaders";
import CustomSelectDropdown from "../CustomHTMLElements/CustomSelectDropdown";
import Paginator from "../Pagination/Pagination.component";
import CustomInputField from "../CustomHTMLElements/CustomInputField";
import useProspectivePrincipals, {
  TBusinessInfo,
  TQuery,
} from "../../custom-hooks/useProspectivePrincipals";
import { useDispatch } from "react-redux";
import { showModal } from "../../redux/actions/modal";
enum prospectivePrincipalStatus {
  Pending = 1,
  Approved = 2,
  Declined = 3,
}

const ProspectivePrincipals = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [size, setSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState({});
  const [query, setQuery] = useState<TQuery>({
    Page: 1,
    PageSize: 10,
    search_value: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    appInsights.trackPageView({
      name: "ProspectivePrincipal.tsx",
      isLoggedIn: true,
    });
  }, []);

  const handleSearch = () => {
    const _query = searchQuery as TQuery;

    return setQuery((prev) => {
      return {
        ...prev,
        ..._query,
      };
    });
  };

  const handleChange = (
    e: ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    if (e.target.value.length === 0) {
      //if it the value is 0 load all existing principal
      return setQuery({
        Page: 1,
        PageSize: 10,
        search_value: "",
      });
    } else {
      setSearchQuery((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value,
        };
      });
    }
  };

  const {
    data: ProspectivePrincipalData,
    status,
    error,
    refetch,
  } = useProspectivePrincipals({
    Page: pageNumber,
    PageSize: size,
    search_value: query?.search_value,
  });

  const approveProspectivePrincipal = (
    currentProspectivePrincipalData: TBusinessInfo,
  ) => {
    dispatch(
      showModal({
        modalIdentifier: "prospectiveprincipalapprovalmodal",
        dataRecord: {
          refetch,
          currentProspectivePrincipalData,
        },
      }),
    );
  };
  const declineProspectivePrincipal = (
    currentProspectivePrincipalData: TBusinessInfo,
  ) => {
    dispatch(
      showModal({
        modalIdentifier: "prospectiveprincipaldeclinemodal",
        dataRecord: {
          refetch,
          currentProspectivePrincipalData,
        },
      }),
    );
  };

  let RenderedComponent = null;
  if (!ProspectivePrincipalData && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Existing Principals
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered={true} text="Loading Existing Principals..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              Existing Principals, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (ProspectivePrincipalData &&
        ProspectivePrincipalData?.data &&
        ProspectivePrincipalData.data?.length === 0) ||
      (ProspectivePrincipalData && !ProspectivePrincipalData?.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no pending
              applications.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>S/N</th>
                  <th>Business Name</th>
                  <th>RC Number</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>State</th>
                  <th>Status</th>
                  <th>Review</th>
                </tr>
              </thead>
              <tbody>
                {ProspectivePrincipalData &&
                  ProspectivePrincipalData?.data.length > 0 &&
                  ProspectivePrincipalData.data?.map(
                    (principalData: TBusinessInfo, _id) => {
                      const {
                        id,
                        rcNumber,
                        businessName,
                        phoneNo,
                        email,
                        state,
                        statusId,
                      } = principalData;
                      return (
                        <tr key={_id}>
                          <td>{(pageNumber - 1) * size + (_id + 1)}</td>
                          <td>{businessName ? businessName : ""}</td>
                          <td>{rcNumber ? rcNumber : ""}</td>
                          <td> {email ? email : ""}</td>
                          <td>{phoneNo ? phoneNo : ""}</td>
                          <td>{state ? state : ""}</td>
                          <td
                            className={`${statusId === prospectivePrincipalStatus.Approved ? "successStatus" : statusId === prospectivePrincipalStatus.Pending ? "pendingStatus" : "declinedStatus"} `}
                          >
                            {statusId === prospectivePrincipalStatus.Approved
                              ? "Approved"
                              : statusId === prospectivePrincipalStatus.Pending
                                ? "Pending"
                                : "Declined"}
                          </td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn zoom-element btn-slim dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              ></button>
                              <div
                                className="dropdown-menu"
                                style={{ textAlign: "center" }}
                                aria-labelledby="dropdownMenuButton"
                              >
                                <span
                                  className="cursor-pointer dropdown-item"
                                  id="custom-rollover-button"
                                  onClick={() =>
                                    approveProspectivePrincipal(principalData)
                                  }
                                >
                                  Approve
                                </span>

                                <span
                                  className="cursor-pointer dropdown-item"
                                  onClick={() => {
                                    declineProspectivePrincipal(principalData);
                                  }}
                                >
                                  Decline
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    },
                  )}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
  return (
    <div className="speed-1x animated fadeInRight">
      <div className={`row `}>
        <div className="col-4">
          <CustomInputField
            type="text"
            name="search_value"
            placeholder="Search Business"
            onChange={handleChange}
          />
        </div>
        <div className="col-2 mt-2">
          <button
            className="btn advancly-btn btn-md "
            disabled={status === "loading"}
            onClick={handleSearch}
          >
            Search {status === "loading" && <ButtonLoader />}
          </button>
        </div>
        <div className="col-4"></div>

        <div className="col-2">
          <CustomSelectDropdown
            onChange={(e) => setSize(Number(e.target.value))}
            value={size}
            name=""
          >
            <option value={10}>10 Entries</option>
            <option value={20}>20 Entries</option>
            <option value={50}>50 Entries</option>
            <option value={100}>100 Entries</option>
          </CustomSelectDropdown>
        </div>
      </div>

      {RenderedComponent}
      <Paginator
        size={size}
        page={pageNumber}
        count={ProspectivePrincipalData?.totalCount}
        changeCurrentPage={(pageNumber: number) => setPageNumber(pageNumber)}
      />
    </div>
  );
};

export default ProspectivePrincipals;
